// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__3iWxK","connect":"styles_connect__3G111","logoContainer":"styles_logoContainer__1SQ8v","logo":"styles_logo__1MXPx"};